/*
 * PEGASI pages
 * ---------------------------------------------------------------------------
 * The scroll-reveal that used to live here has moved into
 * assets/pegasi-motion-system.js, which observes .pg-reveal alongside its own
 * data-pg-m primitives. Running two IntersectionObservers over the same
 * elements meant two schedulers and two sets of layer promotions, and the
 * reveal here never released will-change, so every revealed element kept a
 * compositing layer and rendered its text with greyscale antialiasing.
 *
 * This file is intentionally almost empty: it only guarantees the no-JS
 * fallback class is present if the motion system is unavailable for any
 * reason, so content can never be left hidden.
 */
(() => {
  const root = document.documentElement;
  // If the motion system has not marked itself ready shortly after load,
  // release the reveal guard so nothing stays invisible.
  window.setTimeout(() => {
    if (!root.classList.contains('pg-m-ready')) {
      root.classList.add('pg-m-ready');
      document.querySelectorAll('.pg-reveal, [data-pg-m]').forEach((el) => {
        el.classList.add('is-in');
      });
    }
  }, 2000);
})();
